/**
 * Run callback after LCP (or timeout) — keeps hero/motion off the critical path.
 */
export function afterLcp(callback, timeout = 4500) {
  if (typeof callback !== 'function') {
    return;
  }

  let done = false;
  const run = () => {
    if (done) {
      return;
    }
    done = true;
    callback();
  };

  if (typeof PerformanceObserver === 'undefined') {
    if (document.readyState === 'complete') {
      (window.requestIdleCallback || ((cb) => window.setTimeout(cb, 800)))(run);
    } else {
      window.addEventListener(
        'load',
        () => {
          (window.requestIdleCallback || ((cb) => window.setTimeout(cb, 800)))(run);
        },
        { once: true }
      );
    }
    return;
  }

  try {
    const po = new PerformanceObserver((list, obs) => {
      if (list.getEntries().length) {
        obs.disconnect();
        run();
      }
    });
    po.observe({ type: 'largest-contentful-paint', buffered: true });
    window.setTimeout(() => {
      po.disconnect();
      run();
    }, timeout);
  } catch {
    run();
  }
}
